module.exports = {
    category: {
        myWeeklyPicksException:
            'You have not added your rewards card to your online account. To start earning points online link your card now.',
        tokenizedWeeklyPicksExceptionMessage:
            'Please give us a second chance and hit \'reload page\' to see them.',
        disableCategoryMenuHover: false,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/category.js